import { Field, InputType, Float } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import { type WorkOrder } from '../WorkOrder'
import { RelatedEntity } from '../../base/RelatedEntity'
import type { IAction } from '../../action/IAction'
import { ProductBillOfMaterial } from '../../product/ProductBillOfMaterial'

@InputType()
export class CreateAndBuildWorkOrderArgs extends ActionArgs {
  @Field(() => RelatedEntity)
  product: RelatedEntity

  @Field(() => Float)
  quantity: number

  @Field(() => String)
  remarks?: string

  @Field(() => [String])
  tags?: string[]

  @Field(() => [RelatedEntity])
  relatedSalesOrders: RelatedEntity[]

  @Field(() => String)
  workOrderCode?: string

  /**
   * This is the bill of materials for this whole work order
   * It neeeds to be in tree view structure, normally the output of computeBom
   * it should include also the qty needed to build
   */
  @Field(() => [ProductBillOfMaterial])
  bomItems: ProductBillOfMaterial[]
}

export interface ICreateAndBuildWorkOrder extends IAction<WorkOrder, CreateAndBuildWorkOrderArgs> {}
